module.exports = __webpack_public_path__ + "static/media/SCHAALKLEURSTOF_01.80763c39.png";